import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiConfig from '../config/ApiConfig';
import axios from 'axios';
import { store } from '../store/index';
import { setUserInfo, setUserProfile } from '../containers/Auth/AuthSlices/authSlice';
import { toast } from 'react-toastify';
import { getDeviceId } from '../utils/getDeviceId';

//login user manually api
export const login = createAsyncThunk(
    'auth/login',
    async (values, { rejectWithValue }) => {
        console.log('valuess', values);
        try {
            const deviceId = await getDeviceId();
            const payload = { ...values, deviceId };
            const response = await axios.post(
                `${ApiConfig.auth.login}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Device-Id': deviceId
                    }
                }
            );
            console.log('response login', response);
            store.dispatch(setUserProfile(response?.data?.data));
            if (response?.data?.data && !(response?.data?.data?.roles?.some(r => ["ADMIN", "SUPER_ADMIN"].includes(r)) || response?.data?.data?.role === "admin" || response?.data?.data?.role === "super-admin")) {
                toast.error("Admin account not found with these credentials.");
                store.dispatch(setUserInfo({}))
            }
            if (response.data.error) {
                toast.error(response.data.error);
            }
            return response.data;
        } catch (error) {
            console.log('error in login', error);
            const serverError = error.response?.data?.error || error.response?.data?.message || error.message;
            toast.error(serverError);
            return rejectWithValue(serverError);
        }
    }
);

// otp login by mail
export const otpLoginByMail = createAsyncThunk(
    'auth/sendOtpByMail',
    async (values, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${ApiConfig.auth.sendOtpByMail}`,
                values,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            // console.log('response otp send verification', response);
            if (response?.data?.error) {
                toast.error(response.data.error);
                return rejectWithValue(response.data.error);
            }
            return response.data;
        } catch (error) {
            console.log('error in sendOtpByMail', error);
            const serverError = error.response?.data?.error || error.response?.data?.message || error.message;
            toast.error(serverError);
            if (error.response && (error.response.data.message || error.response.data.error)) {
                return rejectWithValue(error.response.data.error || error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// submit otp
export const submitOtpToResetPassword = createAsyncThunk(
    'auth/submitOtpToResetPassword',
    async (values, { rejectWithValue }) => {
        try {
            const payload = typeof values === 'object' ? values : { otp: values };
            const response = await axios.post(
                `${ApiConfig.auth.submitOtpToResetPassword}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            console.log('response verify otp to reset password', response);
            if (response?.data?.error) {
                toast.error(response.data.error);
                return rejectWithValue(response.data.error);
            }
            return response.data;
        } catch (error) {
            console.log('error in submitOtpToResetPassword', error);
            const serverError = error.response?.data?.error || error.response?.data?.message || error.message;
            toast.error(serverError);
            if (error.response && (error.response.data.message || error.response.data.error)) {
                return rejectWithValue(error.response.data.error || error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// changePassword api
export const changePassword = createAsyncThunk(
    'auth/changePassword',
    async (
        { newPassword, confirmNewPassword, userId },
        { rejectWithValue }
    ) => {
        try {
            const response = await axios.post(
                `${ApiConfig.auth.resetPassword}${userId}`,
                {
                    newPassword,
                    confirmNewPassword,
                    userId
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            if (response?.data?.error) {
                toast.error(response.data.error);
                return rejectWithValue(response.data.error);
            }
            return response.data;
        } catch (error) {
            console.log('error in change password', error);
            const errMsg =
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.message;
            toast.error(errMsg);
            return rejectWithValue(errMsg);
        }
    }
);

// update user profile details
export const updateUserProfile = createAsyncThunk(
    'auth/updateUserProfile',
    async ({ userId, firstName, lastName, contact, countryCode }, { rejectWithValue }) => {
        try {
            const response = await axios.put(
                `${ApiConfig.auth.updateProfile}${userId}`,
                { firstName, lastName, contact, countryCode },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            toast.success("Profile updated successfully!");
            return response.data;
        } catch (error) {
            console.log('error in update profile', error);
            const errMsg = error.response?.data?.error || error.response?.data?.message || error.message;
            toast.error(errMsg);
            return rejectWithValue(errMsg);
        }
    }
);

// update user profile picture
export const updateProfilePicture = createAsyncThunk(
    'auth/updateProfilePicture',
    async ({ file }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('image', file);
            const response = await axios.post(
                `${ApiConfig.auth.updateProfilePicture}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            toast.success("Profile picture updated successfully!");
            return response.data;
        } catch (error) {
            console.log('error in profile picture upload', error);
            const errMsg = error.response?.data?.error || error.response?.data?.message || error.message;
            toast.error(errMsg);
            return rejectWithValue(errMsg);
        }
    }
);

// get current user profile details
export const getMyProfile = createAsyncThunk(
    'auth/getMyProfile',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.userManagment.getMyProfile}`
            );
            return response.data;
        } catch (error) {
            console.log('error in getMyProfile', error);
            const errMsg = error.response?.data?.error || error.response?.data?.message || error.message;
            return rejectWithValue(errMsg);
        }
    }
);